const baseUrl =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || '';

export const DEFAULT_KIOSK_TIMEOUT_MS = 45_000;

let cachedMs = null;
let inflight = null;

function parseMilliseconds(value) {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return Math.round(value);
  }
  if (typeof value === 'string' && value.trim()) {
    const parsed = parseInt(value, 10);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed;
  }
  return null;
}

function extractMilliseconds(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const direct = parseMilliseconds(payload.milliseconds);
  if (direct) return direct;
  const data = payload.data;
  if (data && typeof data === 'object') {
    return parseMilliseconds(data.milliseconds) || parseMilliseconds(data.data?.milliseconds);
  }
  return null;
}

async function loadTimeoutMs() {
  try {
    const response = await fetch(`${baseUrl}/kiosk-timeout-setting`, {
      headers: { accept: '*/*' },
    });
    if (!response.ok) return DEFAULT_KIOSK_TIMEOUT_MS;
    const payload = await response.json();
    return extractMilliseconds(payload) || DEFAULT_KIOSK_TIMEOUT_MS;
  } catch {
    return DEFAULT_KIOSK_TIMEOUT_MS;
  }
}

export async function fetchKioskTimeoutMs() {
  if (cachedMs) return cachedMs;
  if (!inflight) {
    inflight = loadTimeoutMs().finally(() => {
      inflight = null;
    });
  }
  cachedMs = await inflight;
  return cachedMs;
}
